import { gql } from "@apollo/client";

export const SEARCH_DONATION_HISTORY_FORM_NAMES = gql`
  query searchDonationHistoryFormNames(
    $input: SearchDonationHistoryFormNamesInput!
  ) {
    searchDonationHistoryFormNames(input: $input) {
      formNames
    }
  }
`;

export const GET_SUBACCOUNT_DONATION_METADATA = gql`
  query getSubaccountDonationMetadata(
    $input: GetSubaccountDonationMetadataInput!
  ) {
    getSubaccountDonationMetadata(input: $input) {
      earliestDonationDate
      latestDonationDate
    }
  }
`;

export const GET_DONATION_DETAILS = gql`
  query getDonationDetails($input: GetDonationDetailsInput!) {
    getDonationDetails(input: $input) {
      id
      amountInCents
      recurringType
      donatedAt
      firstName
      lastName
      phoneNumber
      address1
      address2
      city
      state
      zipCode
      platform
      formName
      campaign {
        id
        shortId
        name
      }
    }
  }
`;

export const SEARCH_DONATION_HISTORY = gql`
  query searchDonationHistory(
    $subaccountId: String!
    $filter: DonationHistoryFilterInput!
    $limit: Int!
    $offset: Int!
  ) {
    searchDonationHistory(
      input: {
        subaccountId: $subaccountId
        filter: $filter
        limit: $limit
        offset: $offset
      }
    ) {
      id
      amountInCents
      recurringType
      donatedAt
      firstName
      lastName
      phoneNumber
      city
      state
      zipCode
      platform
      formName
      campaign {
        id
        shortId
        name
      }
    }

    getDonationHistoryAggregateData(
      input: { subaccountId: $subaccountId, filter: $filter }
    ) {
      amountRaisedInCents
      count
    }
  }
`;
